import axios, {AxiosResponse} from 'axios'
// import {SAMPLE_REGISTER_RESPONSE} from './sampleResponse'
const API_URL = process.env.REACT_APP_THEME_API_URL
export interface transformedData {
  records: transformedRecord[]
  totalSales?: number | null
  currency?: string | null
  totalCredit: number | null
  totalDebit: number | null
}
const transformRegisterData = (data: RegisterResponse): transformedData => ({
  records: data.records.map(
    (_: Record): transformedRecord => ({
      ledgerId: _.ledger_id,
      ledgerCode: _.ledger_code,
      ledger: _.parent_ledger,
      subLedger: _.sub_ledger.map((sl) => ({
        ledgerId: sl.ledger_id,
        ledgerCode: sl.ledger_code,
        ledger: sl.sub_ledger,
        debit: sl.debit,
        credit: sl.credit,
        parentLedger: null,
      })),

      debit: _.debit,
      credit: _.credit,
    })
  ),

  currency: data?.currency,
  totalCredit: data.total_credit,
  totalDebit: data.total_debit,
  totalSales: data.total_outstanding,
})

export interface transformedRecord {
  ledgerId: number | null
  ledgerCode: string | null
  ledger: string | null
  subLedger?: TransformedSubLedger[]
  debit: number | null
  credit: number | null
}
export interface Record {
  ledger_id: number
  ledger_code: string
  parent_ledger: string
  sub_ledger: SubLedger[]
  debit: number
  credit: number
}

export interface TransformedSubLedger {
  ledgerId: number
  ledgerCode: string
  ledger: string
  debit: number
  credit: number
  // parentLedger: string | null
}
export interface SubLedger {
  ledger_id: number
  ledger_code: string
  sub_ledger: string
  debit: number
  credit: number
  // parentLedger: string | null
}
export interface RegisterResponse {
  records: Record[]
  total_debit: number
  total_credit: number
  total_outstanding: number
  currency?: string
}

export const getRegisterValues = async (
  report_type: string,
  company_id: number,
  fy_name: string,
  from_date: string,
  to_date: string
  // period: string
): Promise<transformedData | undefined> => {
  // return transformRegisterData(SAMPLE_REGISTER_RESPONSE)
  try {
    const response = await axios.post(
      `${API_URL}/accounting/transaction/report/register/`,
      {
        company_id,
        fy_name,
        from_date,
        to_date,
        report_name: 'register',
        report_type,
        // period,
      },
      {
        validateStatus: () => true,
      }
    )
    if (!response) {
      throw new Error('Internal Server Error')
    }

    if (response.data && response.data.status && response.data.status === 'error') {
      throw new Error(response.data.message)
    }
    return transformRegisterData(response.data)
  } catch (err: any) {
    if (err) throw err
  }
}
